(() => {
  let typingTimer;
  let initialized = false;

  function initCartGift() {
    // Only set up event delegation once
    if (initialized) return;
    initialized = true;

    // Event delegation for textarea input - works for dynamically added elements
    document.addEventListener('input', (event) => {
      if (event.target.matches('[data-gift-textarea]')) {
        clearTimeout(typingTimer);
        const loader = document.querySelector('[data-gift-loader]');
        if (loader) {
          typingTimer = setTimeout(() => {
            saveGiftMessage(event.target.value.trim(), loader);
          }, 400);
        }
      }
    });

    // Event delegation for toggle change - works for dynamically added elements
    document.addEventListener('change', (event) => {
      if (event.target.matches('[data-gift-toggle]')) {
        const wrapper = document.querySelector('[data-gift-wrapper]');
        if (wrapper) {
          wrapper.hidden = !event.target.checked;
        }
      }
    });
  }

  function saveGiftMessage(message, loader) {
    startLoader(loader);

    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        attributes: { 'Gift Note: ': message },
        note: 'Gift Note: ' + message
      }),
    })
      .then((res) => res.json())
      .then(() => finishLoader(loader))
      .catch(() => finishLoader(loader));
  }

  function startLoader(loader) {
    loader.classList.remove('done');
    loader.classList.add('working');
    loader.textContent = 'Saving...';
  }

  function finishLoader(loader) {
    loader.classList.remove('working');
    loader.classList.add('done');
    loader.textContent = 'Saved';

    setTimeout(() => {
      loader.classList.remove('done');
    }, 700);
  }

  // Initialize once on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCartGift);
  } else {
    initCartGift();
  }
})();